import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //首页任务文字
    taskText:'赏金猎人限时任务：每天前3次通关生化危机大作战-镜花水月困难或困难以上难度，可获得额外的犒赏！',
    //靶场军需模块数据
    bcData: {
      Date: "4月23日—4月29日",
      rangeList: [
        "暴君-原始咆哮（3/7天）概率翻五倍",
        "超能-毁灭镭射（3/7天）概率翻五倍",
        "毁灭者专属材料、冻结者专属材料",
        "破片过滤网（永久）"
      ]
    },
    jxData: {
      Date: "2019年4月16日—2019年4月29日",
      jxList: ['离子先锋时空箱（稀有）','设计图：晶能电源 Mk.6']
    },

    //免费福利模块数据
    freePropsData: {
      pageDate: "4月16日——4月29日",
      allPeople: [
       // 'AUG','破军HK21','毛瑟M1932','精钢Hawker-1','破军-守备官','静音装置'
        //  'USP','破军AN94','魔煞UMP9','精钢QBU88','毛瑟M1932','力量增幅器'
         'M249_SAW','退魔AA12','军灵AWP','精钢AK47','精钢FN57','移动装置'
      ],
      vip: ['高碳怒焰风暴','钛钢UMP9','破军光束剑']

    },
    // saleTime 为saleTIme 模块的数据 
    // saleTime1: {
    //   num: "01",
    //   saleDate: "3月26日——4月8日",
    //   title: "III型装置",
    //   saleWay: "限时特卖",
    //   p: [
    //     `活动期间玩家可在商城内购买到“<span style="color:red">体质增强器III型以小搏大包、移动装置III型以小搏大包</span>”，打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">体质增强装置III型、移动装置III型</span>（至少可获得3天期限）。以小搏大，圆你永久梦想!。`,

    //   ],
    //   span: []
    // },

    // saleTime1: {
    //   num: "01",
    //   saleDate: "4月9日维护后——4月16日维护前",
    //   title: "神器升阶材料",
    //   saleWay: "限时销售",
    //   p: [
    //     `活动期间玩家可在游戏内商城购买<span style="color:red">地狱浩劫核心模块、碎星炮核心模块、毒液之牙核心模块、疾雨流星核心模块，</span>助你轻松升级你的超级神器。`,
    //     `活动期间玩家可在游戏内商城购买<span style="color:red">神器碎片特惠礼包，</span>助你轻松升级你的超级神器。`,
    //   ],
    //   span: []

    // },
    // saleTime2: {
    //   num: "02",
    //   saleDate: "4月9日维护后——4月16日维护前",
    //   title: "稀有时装",
    //   saleWay: "限时特卖",
    //   p: [
    //     `活动期间玩家可在商城内购买到<span style="color:red">“都市白领（男/女）以小搏大包”，</span>
    //     打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">都市白领（男/女）</span>一套（至少可获得3天期限）。`,
    //     `以小搏大，圆你永久梦想！。`,
    //   ],
    //   span: []    
    
    // },
    // saleTime3: {
    //   num: "03",
    //   saleDate: "4月9日维护后——4月16日维护前",
    //   title: "机友强化大礼包",
    //   saleWay: "限时特卖",
    //   p: [
    //     `1、活动期间玩家可在游戏内商城以原价商品8折的特惠购买<span style="color:red;">机友强化包（死亡之翼专属）、机友强化包（杀手专属）、机友强化包（巨龙专属）、机友强化包（机甲专属）、机友强化包（死神专属）、机友强化包（巨炮专属）；</span>`,
    //     `礼包内物品包括：特定机友专属插件LV1，机友插件随机包x1，能量棒x50；`,
    //     `针对特定机友而度身定制的强化礼包，使你的小伙伴拥有超强战斗力。`,
    //     `2、活动期间玩家可在游戏内商城以原价商品8折的特惠购买<span style="color:red;">机友强化包（闪电霹雳版）；</span>`,
    //     `礼包内物品包括：闪电霹雳Lv1，机友插件随机包x1，能量棒x50；`,
    //     `内含所有机友都可装备的超强插件“闪电霹雳”，使你的小伙伴迅速Hold住全场。`,
    //   ],
    //   span: []    
    
    // }   
    saleTime1: {
      num: "01",
      saleDate: "4月16日维护后——4月29日维护前",
      title: "周年限定时装",
      saleWay: "限时销售",
      p: [
        `活动期间玩家可在商城内购买到<span style="color:red">“粉心黑衣/荧星魅兔以小搏大包”，</span>打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">“粉心黑衣/荧星魅兔”</span>一套（至少可获得3天期限）。`,
        `以小搏大，圆你永久梦想！`,
      ],
      span: []

    },
    saleTime2: {
      num: "02",
      saleDate: "4月16日维护后——4月29日维护前",
      title: "周年限定挂件",
      saleWay: "限时销售",
      p: [
        `活动期间玩家可在商城内购买到<span style="color:red">“8周年庆典涂装枪管（冻结者专属）以小搏大包”</span>
        打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">8周年庆典涂装枪管（冻结者专属）</span>一套（至少可获得3天期限）。`,
        `以小搏大，圆你永久梦想！`,
      ],
      span: []    
    
    },
    saleTime3: {
      num: "03",
      saleDate: "4月16日维护后——4月29日维护前",
      title: "传承专属材料",
      saleWay: "限时销售",
      p: [
        `活动期间玩家可在游戏内商城购买<span style="color:red;">邪能行者专属材料</span>助你轻松升级你的传承武器。`,
      ],
      span: []    
    
    },
    saleTime4: {
      num: "04",
      saleDate: "4月23日维护后——4月29日维护前",
      title: "君临天下大礼包",
      saleWay: "限时销售",
      p: [
        `活动期间玩家可在游戏内商城购买<span style="color:red;">“君临天下大礼包”</span>，打开即可获得：<span style="color:red;">暴君-稳定芯片，暴君武器幸运包（7天）</span>；`,
        `<span style="color:red;">暴君-稳定芯片</span>：`,
        `结合史前神秘云石制作的暴君武器专用挂件，可提高瞄准状态下的射击稳定。`,
        `“暴君武器专用”`,
        `“加装芯片后将自动与武器绑定，当武器到期后将自动卸载”`,
      ],
      span: []    
    
    },
    saleTime5: {
      num: "05",
      saleDate: "4月23日维护后——4月29日维护前",
      title: "辉煌暴君大礼包",
      saleWay: "限时销售",
      p: [
        `活动期间玩家可在游戏内商城购买<span style="color:red;">“辉煌暴君大礼包”</span>，打开即可获得：<span style="color:red;">暴君-精准芯片，暴君武器幸运包（7天）</span>；`,
        `<span style="color:red;">暴君-精准芯片</span>：`,
        `结合史前神秘云石制作的暴君武器专用挂件，能够增加瞄准射击精度。`,
        `“暴君武器专用”`,
        `“加装芯片后将自动与武器绑定，当武器到期后将自动卸载”`,
      ],
      span: []    
    
    },
    saleTime6: {
      num: "06",
      saleDate: "4月23日维护后——4月29日维护前",
      title: "ID识别卡",
      saleWay: "限时特卖",
      p: [
        `1、活动期间玩家可以在游戏内商城以<span style="color:red;">原价8.5折的优惠购买ID识别卡（50）特惠包，礼包内含：“ID识别卡x50+军需补给箱x50”；</span>`,
        `2、活动期间玩家可以在游戏内商城以<span style="color:red;">原价7.5折的优惠购买ID识别卡（100）特惠包，礼包内含“ID识别卡x100+军需补给箱x100”；</span>`,
        `使用ID识别卡可开启军需补给箱，开启补给箱100%获奖，所有奖品都为点券商品。除了数十种永久武器装备外，更有机会获得游戏中从未出售过的极品非卖商品。`,
      ],
      span: []    
    },
    saleTime7: {
      num: "07",
      saleDate: "4月23日维护后——4月29日维护前",
      title: "ID识别卡",
      saleWay: "限时特卖",
      p: [
        `1、活动期间玩家可以在游戏内商城以<span style="color:red;">原价7.5折的超值优惠购买“搞机箱x100”；</span>`,
        `打开“搞机箱”可随机获得包括“歼星巨龙时空箱（稀有）、闪电霹雳插件Lv1、能量棒”等机友商品，更有机会获得“加农巨炮（史诗）、天空杀手（史诗）、冷酷死神（史诗）”机友时空箱！`,
      ],
      span: []    
    }
  },
  getters: {
    taskText:state => state.taskText,
    bcData: state => state.bcData,
    jxData: state => state.jxData,
    freePropsData: state => state.freePropsData,
    saleTime1: state => state.saleTime1,
    saleTime2: state => state.saleTime2,
    saleTime3: state => state.saleTime3,
    saleTime4: state => state.saleTime4,
    saleTime5: state => state.saleTime5,
    saleTime6: state => state.saleTime6,
    saleTime7: state => state.saleTime7,
  }

})



// WEBPACK FOOTER //
// ./src/store/index.js